var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F5FAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.9995V22.9995C30 25.4995 29.5 27.2495 28.38 28.3795L22 21.9995L29.73 14.2695C29.91 15.0595 30 15.9595 30 16.9995Z",
    stroke: "#0090D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.73 14.27L14.27 29.73C11.26 29.04 10 26.96 10 23V17C10 12 12 10 17 10H23C26.96 10 29.04 11.26 29.73 14.27Z",
    stroke: "#0090D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.38 28.38C27.25 29.5 25.5 30 23 30H17C15.96 30 15.06 29.91 14.27 29.73L22 22L28.38 28.38Z",
    stroke: "#0090D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2398 15.9807C14.9198 13.0507 19.3198 13.0507 19.9998 15.9807C20.3898 17.7007 19.3098 19.1607 18.3598 20.0607C17.6698 20.7207 16.5798 20.7207 15.8798 20.0607C14.9298 19.1607 13.8398 17.7007 14.2398 15.9807Z",
    stroke: "#0090D1",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0946 16.6992H17.1036",
    stroke: "#0090D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSex);
export default __webpack_public_path__ + "static/media/sex.4c37d94d6106102e21adcedf3000200a.svg";
export { ForwardRef as ReactComponent };